module.exports = __webpack_public_path__ + "static/media/icon_clock.038ad609.svg";